var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout",attrs:{"id":"app"}},[_c('Nav',{key:_vm.renderNav,class:_vm.currentRouteName =='home' ? 'nav-transparent': ''}),_c('router-view',{key:_vm.renderRouterView,attrs:{"id":"view-container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }